import React, { FC } from 'react';
import { Rocket } from './Rocket';
import { Link } from './Link';
import { DeviceType } from './App';
import { Box, Button } from '@fabric-ds/react';

export type Props = {
    deviceType: DeviceType;
};

export const DefaultPanel: FC<Props> = ({ deviceType }) => {
    return (
        <Box className="flex flex-col-reverse items-center space-y-24 sm:flex-row sm:space-x-16" info={true}>
            <div className="text-16 leading-22 flex w-fit flex-col space-y-16 pb-20">
                <h2 className="h3">Sørg for at boligsalget blir en suksess</h2>
                <>
                    <p>
                        For å ikke gå glipp av potensielle interessenter velger mange å markedsføre boligen litt ekstra
                        med BLINK-teknologi.
                    </p>
                    <p>Opptil dobbelt så mye trafikk på annonsen!</p>
                </>
                <Link
                    link="https://www.finn.no/realestate/artikler/blink-teknologi-finn-eiendom"
                    page="realestate-marketpage"
                    className="button button--default"
                    deviceType={deviceType}
                />
            </div>
            <div className="pb-40">
                <Rocket className="sm:w-144 sm:h-144 h-80 w-80" />
            </div>
        </Box>
    );
};

export const VeksthusPanel: FC<Props> = () => {
    return (
        <Box info className="rounded-8 flex flex-col items-center space-y-24 text-gray-700 sm:items-start">
            <h2 className="h2 sm:h3 max-w-3/4 text-center">Vi har pusset opp i FINN eiendom!</h2>
            <div className="max-w-3/4 flex flex-col sm:w-full">
                <div className="flex space-x-8">
                    <CheckBoxIcon className="mt-6 flex-none" />
                    <p>samme rekkefølge på annonsene som før</p>
                </div>
                <div className="flex space-x-8 sm:w-full">
                    <CheckBoxIcon className="mt-6 flex-none" />
                    <p>noen av annonsene er større</p>
                </div>
            </div>
            <Button
                className="z-10"
                secondary
                href="https://www.finn.no/realestate/artikler/kjope-bolig/hurra-na-lanserer-vi-spennende-nyheter-pa-finn-eiendom"
            >
                Les om de nye annonseformatene
            </Button>
            <div style={{ minWidth: '105%' }} className="h-144 relative -mx-16 w-screen sm:h-auto sm:w-full">
                <Curve className="absolute top-2/3 w-screen sm:top-auto sm:bottom-1/2 sm:w-full" />
                <FinnBox
                    className="absolute left-1/4 bottom-0 sm:left-auto sm:right-0 sm:bottom-0"
                    style={{ height: '150px', width: '166px' }}
                />
            </div>
        </Box>
    );
};

const FinnBox: FC<React.SVGProps<SVGSVGElement>> = ({ style, className }) => {
    return (
        <svg className={className} style={style} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 167 172">
            <path
                fill="#fff"
                stroke="#C3CCD9"
                d="M67.462 38.7298c16.9489-8.1131 37.345-2.6864 47.943 12.7546.562.8186 1.097 1.6654 1.601 2.5397L83.8727 73.1539 64.8062 40.1298c.8744-.5048 1.7603-.9713 2.6558-1.4Z"
            />
            <path
                fill="#0063FB"
                d="M112.799 52.989c-9.754-14.0066-28.3204-18.9531-43.832-11.6531l16.0038 27.7195L112.799 52.989Z"
            />
            <path
                fill="#fff"
                fillRule="evenodd"
                stroke="#C3CCD9"
                d="M55.0191 37.1487c9.3643-2.3922 15.0788-11.6778 12.7638-20.74-2.3151-9.06218-11.783-14.46926-21.1472-12.07707-9.3643 2.3922-15.0788 11.67777-12.7638 20.73997 2.315 9.0622 11.783 14.4693 21.1472 12.0771Z"
                clipRule="evenodd"
            />
            <path
                fill="#FFF5C8"
                d="M54.2766 34.2419c7.8495-2.0052 12.4818-9.723 10.5996-17.0907-1.8822-7.36779-9.6485-11.91821-17.498-9.91297C39.5286 9.24347 34.8964 16.9612 36.7785 24.329c1.8822 7.3678 9.6485 11.9182 17.4981 9.9129Z"
            />
            <ellipse cx="89.8698" cy="159.243" fill="#94A3B8" opacity=".5" rx="74.1301" ry="12.3721" />
            <path
                fill="#B59568"
                d="M.9375 66.5586c3.83039 6.6791 6.15103 10.3133 7.5 18.5902h63.5c-4.7504-5.8749-7.0963-9.2068-15-14.6992l-56-3.891Z"
            />
            <path
                fill="#fff"
                stroke="#C3CCD9"
                d="m51.7341 57.615-26.9275 5.6243 7.9605 23.9064 26.9275-5.6242-7.9605-23.9065Z"
            />
            <path fill="#06BEFB" d="m28.691 65.4717 21.0543-4.3975 6.0649 18.2137-21.0542 4.3975-6.065-18.2137Z" />
            <path
                fill="#C9AC82"
                d="M22.382 161.88 8.27444 87.0747c-.44491-2.3591 1.27392-4.576 3.66946-4.7327l89.2361-5.84-17.2084 89.979-61.5896-4.601Z"
            />
            <path
                fill="#B59568"
                d="m145.47 78.5844-44.622-2.0824-17.286 89.979 47.869-10.123 16.825-74.1127c.413-1.8214-.92-3.5738-2.786-3.6609Z"
            />
            <path fill="#D4BD9B" d="m59.2953 164.607-14.6266-1.125-3.989-82.8554 21.6074-1.4996-2.9918 85.48Z" />
            <path
                fill="#A9895A"
                d="M123.938 62.2354c-7.285 1.5643-12.986 6.2582-23 14.2669l47 4.7556c3.902-7.7302 8.788-9.6561 15.5-13.4022l-39.5-5.6203Z"
            />
            <g fill="#fff" fillRule="evenodd" clipRule="evenodd" opacity=".8">
                <path d="m104.552 98.9751 1.409-13.2366c.028-.261.182-.4595.343-.4424l2.583.2749c3.24.3448 5.421 4.8977 4.862 10.1492l-.496 4.6598-8.459-.9004c-.161-.0171-.269-.2434-.242-.5045Zm27.562 2.9329c-.028.261-.181.46-.342.443l-17.863-1.901 1.46-13.7104c.027-.2611.181-.4595.342-.4424l17.57 1.8699c.161.0172.27.2436.242.5046l-1.409 13.2363Zm1.281-14.805-17.57-1.8699c-.524-.0557-1.023.5888-1.113 1.4368l-.471 4.4267c-.686-3.6407-2.661-6.3153-5.241-6.5899l-2.583-.2749c-.523-.0556-1.022.5889-1.112 1.4368l-1.409 13.2366c-.09.8479.262 1.5828.785 1.6388l26.977 2.871c.524.056 1.023-.589 1.113-1.437l1.409-13.2363c.09-.8479-.262-1.583-.785-1.6387Z" />
                <path d="m125.496 91.7135.662.0706c.103.0109.172.1549.154.3215l-.524 4.9275c-.018.1666-.116.2927-.218.2818l-.531-.0565c-.084-.0089-.155-.0856-.189-.204l-.746-2.6159-.255 2.3883c-.017.1666-.115.2927-.218.2818l-.662-.0705c-.103-.011-.172-.1548-.154-.3214l.524-4.9276c.018-.1666.115-.2928.218-.2818l.509.0541c.084.0089.154.0848.188.2023l.766 2.6479.257-2.4162c.018-.1666.116-.2928.219-.2819Zm4.653.4954-.662-.0706c-.103-.0109-.201.1153-.218.2819l-.258 2.4162-.766-2.6479c-.034-.1174-.104-.1934-.188-.2023l-.509-.0541c-.102-.011-.2.1152-.218.2818l-.524 4.9276c-.018.1666.051.3104.154.3214l.663.0705c.102.0109.2-.1152.218-.2818l.254-2.3883.747 2.6159c.033.1184.104.1951.188.204l.531.0565c.103.0109.2-.1152.218-.2818l.525-4.9275c.017-.1666-.052-.3106-.155-.3215Zm-12.227-1.3013 2.366.2518c.103.011.172.1549.154.3215l-.101.9463c-.018.1666-.115.2928-.218.2818l-1.517-.1614-.133 1.2484 1.208.1285c.103.011.172.1549.154.3215l-.086.8056c-.018.1666-.115.2928-.218.2819l-1.208-.1286-.109 1.0223c-.017.1666-.115.2927-.218.2818l-.663-.0705c-.102-.011-.171-.1548-.154-.3214l.525-4.9276c.017-.1666.115-.2928.218-.2819Zm3.582.3814.663.0705c.103.011.172.1549.154.3215l-.524 4.9275c-.018.1667-.116.2929-.218.2819l-.663-.0705c-.103-.0109-.172-.1549-.154-.3215l.524-4.9275c.018-.1666.116-.2929.218-.2819Z" />
            </g>
        </svg>
    );
};

const Curve: FC<React.SVGProps<SVGSVGElement>> = ({ className, style }) => {
    return (
        <svg className={className} style={style} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 621 81">
            <path
                fill="url(#a)"
                fillOpacity=".15"
                d="M0 33.5c192 0 323.942 9.0661 621-33.5v81H0V33.5Z"
                style={{ mixBlendMode: 'multiply' }}
            />
            <defs>
                <linearGradient id="a" x1="310.246" x2="310.246" y1="8.08316" y2="98" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#6A6A6A" />
                    <stop offset="1" stopColor="#C4C4C4" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

const CheckBoxIcon: FC<React.SVGProps<SVGSVGElement>> = ({ className, style }) => {
    return (
        <svg
            role="img"
            aria-label="✓"
            className={className}
            style={style}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.007 4.447a.75.75 0 01.046 1.06l-5.5 6a.75.75 0 01-1.083.023l-3-3a.75.75 0 011.06-1.06l2.446 2.446 4.971-5.423a.75.75 0 011.06-.046z"
                clipRule="evenodd"
            />
        </svg>
    );
};
